import { render } from "./ListeMatierePage.vue?vue&type=template&id=cbd89844&ts=true"
import script from "./ListeMatierePage.vue?vue&type=script&lang=ts"
export * from "./ListeMatierePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__